import React from 'react';
import AltIso from 'alt/utils/AltIso';
import withRouter from '../utils/with-router';

import connectToStores from 'alt/utils/connectToStores';

import ShiftPaymentForm from '../forms/ShiftPaymentForm'

import PaymentStore from '../stores/PaymentStore';
import ShiftStore from '../stores/ShiftStore';
import ShiftActions from '../actions/ShiftActions';

@AltIso.define((props) => {
    return Promise.all([
        PaymentStore.getPayments()
    ]);
})
@connectToStores
@withRouter
class CreateShiftStep3 extends React.Component {
    constructor(props) {
        super(props);
    }

    static getPropsFromStores() {
        return {
            paymentStore: PaymentStore.getState(),
            shiftStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [PaymentStore, ShiftStore];
    }

    saveShift() {
        const data = this.refs.form.getValue();
        const errors = this.refs.form.validate(true).errors;
        if (errors) {
            ShiftActions.mergeErrorsIntoState(errors);
        }
        if (data) {
            // Submit all the things
            ShiftActions.createShift(this.props.shiftStore.stepOneData, this.props.shiftStore.stepTwoData, data, this.props.changeStep, this.context.router)
        }
    }

    getPublishButton() {
        let button = '';

        if (this.props.user.can_apply) {
            button = <button onClick={this.saveShift.bind(this)} className="btn btn-small btn-green">Publish</button>;
        } else {
            button = <button className="btn btn-small btn-gray btn-tooltip btn-tooltip-left" disabled>Publish<div className="btn-tooltip-content">User not active</div></button>;
        }

        return button
    }

    back(e) {
        e.preventDefault();
        this.props.changeStep.call(this, 2);
    }

    render () {
        return (
            <div className="create-shift-step-content create-shift-step3">
                <ShiftPaymentForm
                    onChange={this.props.onChange}
                    initialFormData={this.props.shiftStore.stepThreeData}
                    errors={this.props.shiftStore.createError}
                    ref="form"
                    payments={this.props.paymentStore.payments} />

                <div className="finish-form-buttons">
                    {this.getPublishButton()}
                    <button onClick={this.props.saveDraft} className="btn-transparent">SAVE AS DRAFT</button>
                    <button onClick={this.back.bind(this)} className="btn-transparent">BACK</button>
                </div>
            </div>
        );
    }
}

export default CreateShiftStep3;



/** WEBPACK FOOTER **
 ** ./app/src/components/CreateShiftStep3.js
 **/